import OspreyTypedValueMetadata from './typed-value-metadata'
import OspreyTypedValuePost from './typed-value-post'
import OspreyTypedValueGet from './typed-values'

export default class TypedValues {

    getMetadata() {
        return new OspreyTypedValueMetadata()
    }

    createTypedValue() {
        return new OspreyTypedValuePost()
    }

    getTypedValues() {
        return new OspreyTypedValueGet()
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/typed-value/index.js